import { API_URL, jwtToken } from "../../../context/appContext";
export default async function cancelTriangularOrder(id, botId) {
    return fetch(`${API_URL}/api/triangular_process/${id}/${botId}/cancel`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => console.log({ err }))
}
